import React from "react";
import { Layout } from "src/components/layout/Layout";
import { ModuleRouter } from "src/components/molecules";
import { YardRoute } from "./yard.routes";

export function YardManagement() {
  return (
    <Layout>
      {YardRoute.subRoutes && (
        <ModuleRouter subRoutes={YardRoute.subRoutes} path={YardRoute.path} />
      )}
    </Layout>
  );
}
